<!-- Base.Breadcrumb.vue (client-lms) -->
<template>
  <div class="lms_breadcrumb">
    <router-link :to="to">
      <i class="mdi mdi-chevron-left" style="font-size: 16px"></i>
      {{ label }}
    </router-link>
    <!-- 여백은 화면 CSS(.pcp_crumb 등)의 gap 이 준다 — 인라인 margin 을 주면 뒤로가기 버튼과 세로 정렬이 어긋난다 -->
    <span v-if="courseNm != null && courseNm != ''" :class="cssClass">{{ courseNm }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps({
  to: { type: String, required: true },
  label: { type: String, default: "목록으로" },
  courseNm: { type: String, default: "" },
  cssClass: { type: String, default: "" },
});
</script>
